<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2026-10-26 16:09:18
 * @LastEditTime: 2026-10-29 09:56:20
 * @Description: 上料数据补录
 * @Param:
 * @FilePath: \ProjectTree_vue2\ConcreteCloud_Web\src\views\weighbridgeManagement\materialLoadingDataQuery\supplementaryRegistrationForm.vue
 -->

<template>
    <div v-loading="loading" class="supplementaryRegistrationForm">
        <div class="supplementaryRegistrationFormContent">
            <!-- 基础信息 -->
            <div class="table-container">
                <table class="custom-table">
                    <tbody>
                        <tr>
                            <td colspan="4" class="table-tit">
                                <span>选择过磅单</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit" style="width: 15%;">
                                <span style="color: red;">*</span>
                                过磅单号：
                            </td>
                            <td class="tdStyle1" style="width: 35%;" @click="openSelectTable('slbl_xzgbd', 'selectWeighingSlipBack')">
                                <el-input v-model="formData.gbdbh" placeholder="请选择过磅单">
                                    <i slot="suffix" class="iconfont icon009"></i>
                                </el-input>
                            </td>
                            <td class="column-tit" style="width: 15%;">
                                供应单号：
                            </td>
                            <td class="tdStyle1" style="width: 35%;">
                                <el-input v-model="formData.gydh" placeholder="请选择过磅单" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit" style="width: 15%;">
                                <span style="color: red;">*</span>
                                车牌号：
                            </td>
                            <td class="tdStyle1" style="width: 35%;">
                                <el-input v-model="formData.cph" placeholder="请选择过磅单" disabled></el-input>
                            </td>
                            <td class="column-tit" style="width: 15%;">
                                上料组编码：
                            </td>
                            <td class="tdStyle1" style="width: 35%;">
                                <el-input v-model="formData.slzbh" placeholder="请输入上料组编码"></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-container">
                <table class="custom-table">
                    <tbody>
                        <tr>
                            <td colspan="4" class="table-tit">
                                <span>上料结果</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit" style="width: 15%;">
                                <span style="color: red;">*</span>
                                料仓编号：
                            </td>
                            <td class="tdStyle1" style="width: 35%;" @click="openSelectTable('ycl_gbdgl_xzlc', 'selectSiloBack')">
                                <el-input v-model="formData.lcbh" placeholder="请选择料仓">
                                    <i slot="suffix" class="iconfont icon009"></i>
                                </el-input>
                            </td>
                            <td class="column-tit" style="width: 15%;">
                                料仓名称：
                            </td>
                            <td class="tdStyle1" style="width: 35%;">
                                <el-input v-model="formData.lcmc" placeholder="请选择料仓" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit">
                                原材料名称：
                            </td>
                            <td>
                                <el-input v-model="formData.yclmc" placeholder="请选择料仓" disabled></el-input>
                            </td>
                            <td class="column-tit">
                                <span style="color: red;">*</span>
                                放料口：
                            </td>
                            <td>
                                <el-radio-group v-model="formData.flkbm" @change="selectDischargePort">
                                    <template v-for="(label, value) in portMap">
                                        <el-radio :label="value" :key="value">
                                            {{ label }}
                                        </el-radio>
                                    </template>
                                    <!-- <el-radio :label="1">
                                        1口
                                    </el-radio>
                                    <el-radio :label="2">
                                        2口
                                    </el-radio>
                                    <el-radio :label="3">
                                        3口
                                    </el-radio> -->
                                </el-radio-group>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-container">
                <table class="custom-table">
                    <tbody>
                        <tr>
                            <td colspan="4" class="table-tit">
                                <span>时间信息</span>
                                <button class="title-btn" @click="generateAll">
                                    全部生成
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit" style="width: 15%;">
                                <span style="color: red;">*</span>
                                上料开始时间：
                            </td>
                            <td class="tdStyle2" style="width: 35%;">
                                <div class="selectTime">
                                    <el-date-picker v-model="value1" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                                    <el-select v-model="hourData.slkssj" placeholder="请选择时间">
                                        <el-option v-for="item in timeList" :key="item.key" :value="item.key" :label="item.name"></el-option>
                                    </el-select>
                                    <el-button type="primary" plain @click="generateTime('slkssj', 'value1')">
                                        生成
                                    </el-button>
                                </div>
                                <el-input v-model="formData.slkssj" class="timeText" placeholder="请生成时间" disabled></el-input>
                            </td>
                            <td class="column-tit" style="width: 15%;">
                                <span style="color: red;">*</span>
                                上料结束时间：
                            </td>
                            <td class="tdStyle2" style="width: 35%;">
                                <div class="selectTime">
                                    <el-date-picker v-model="value2" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :disabled-date="disabledEndDate1"></el-date-picker>
                                    <el-select v-model="hourData.sljssj" placeholder="请选择时间">
                                        <el-option v-for="item in timeList" :key="item.key" :value="item.key" :label="item.name" :disabled="isEndHourDisabled1(item.key)"></el-option>
                                    </el-select>
                                    <el-button type="primary" plain @click="generateTime('sljssj', 'value2')">
                                        生成
                                    </el-button>
                                </div>
                                <el-input v-model="formData.sljssj" class="timeText" placeholder="请生成时间" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td class="column-tit">
                                <span style="color: red;">*</span>
                                车辆卸料开始时间：
                            </td>
                            <td class="tdStyle2">
                                <div class="selectTime">
                                    <el-date-picker v-model="value3" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :disabled-date="disabledEndDate3"></el-date-picker>
                                    <el-select v-model="hourData.xlkssj" placeholder="请选择时间">
                                        <el-option v-for="item in timeList" :key="item.key" :value="item.key" :label="item.name" :disabled="isUnloadStartHourDisabled(item.key)"></el-option>
                                    </el-select>
                                    <el-button type="primary" plain @click="generateTime('xlkssj', 'value3')">
                                        生成
                                    </el-button>
                                </div>
                                <el-input v-model="formData.xlkssj" class="timeText" placeholder="请生成时间" disabled></el-input>
                            </td>
                            <td class="column-tit">
                                <span style="color: red;">*</span>
                                车辆卸料结束时间：
                            </td>
                            <td class="tdStyle2">
                                <div class="selectTime">
                                    <el-date-picker v-model="value4" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :disabled-date="disabledEndDate2"></el-date-picker>
                                    <el-select v-model="hourData.xljssj" placeholder="请选择时间">
                                        <el-option v-for="item in timeList" :key="item.key" :value="item.key" :label="item.name" :disabled="isEndHourDisabled2(item.key)"></el-option>
                                    </el-select>
                                    <el-button type="primary" plain @click="generateTime('xljssj', 'value4')">
                                        生成
                                    </el-button>
                                </div>
                                <el-input v-model="formData.xljssj" class="timeText" placeholder="请生成时间" disabled></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <footer>
            <el-button type="primary" class="save" @click="save" :loading="saveBtnLoading">
                保存
            </el-button>
            <el-button class="Close" @click="Close">
                关闭
            </el-button>
        </footer>
    </div>
</template>

<script>
export default {
    // 信息价合同调价
    name: 'info-price-contract-price',
    components: {},
    props: {
        extr: {
            type: [Object],
        },
    },
    data() {
        return {
            loading: false,
            formData: {
                id: '',
                gbdbh: '',
                gbdid: '',
                slzbh: '',
                slkssj: '',
                sljssj: '',
                cph: '',
                czbm: '',
                czmc: '',
                xlkssj: '',
                xljssj: '',
                lcbh: '',
                flkmc: '',
                flkbm: '',
                remarks: '',
                is_supplement: true,
                gydh: '',
                lcmc: '',
                yclmc: ''
            },
            timeList: [],
            value1: '',
            value2: '',
            value3: '',
            value4: '',
            hourData: {
                slkssj: '',
                sljssj: '',
                xlkssj: '',
                xljssj: '',
            },
            portMap: {
                1: '1口',
                2: '2口',
                3: '3口',
            },
            saveBtnLoading: false,
        };
    },
    async created() {
        if (this.extr?.id) {
            this.formData = await this.initRequest(this.extr.id);
        }
        this.initTimeFields();
    },
    mounted() {
        this.initTimeList();
    },
    watch: {
        value1(val) {
            if (val && this.value2 && this.value2 < val) {
                this.value2 = '';
                this.hourData.sljssj = '';
            }
        },
        value3(val) {
            if (val && this.value4 && this.value4 < val) {
                this.value4 = '';
                this.hourData.xljssj = '';
            }
        },
        value2(val) {
            if (val && this.value3 && this.value3 < val) {
                this.value3 = '';
                this.hourData.xlkssj = '';
                this.value4 = '';
                this.hourData.xljssj = '';
            }
        },
        'hourData.slkssj'(val) {
            if (val && this.value2 === this.value1 && this.hourData.sljssj && this.hourData.sljssj < val) {
                this.hourData.sljssj = '';
            }
        },
        'hourData.sljssj'(val) {
            if (val && this.value3 === this.value2 && this.hourData.xlkssj && this.hourData.xlkssj < val) {
                this.hourData.xlkssj = '';
                this.hourData.xljssj = '';
            }
        },
        'hourData.xlkssj'(val) {
            if (val && this.value4 === this.value3 && this.hourData.xljssj && this.hourData.xljssj < val) {
                this.hourData.xljssj = '';
            }
        },
    },
    computed: {},
    methods: {
        initTimeList() {
            this.timeList = [];
            for (let i = 0; i < 24; i++) {
                const hour = i < 10 ? '0' + i : '' + i;
                this.timeList.push({
                    name: hour + ' 时',
                    key: hour,
                });
            }
        },
        getTodayStr() {
            const d = new Date();
            return `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())}`;
        },
        initTimeFields() {
            const today = this.getTodayStr();
            const map = [
                { field: 'slkssj', dateField: 'value1' },
                { field: 'sljssj', dateField: 'value2' },
                { field: 'xlkssj', dateField: 'value3' },
                { field: 'xljssj', dateField: 'value4' },
            ];
            map.forEach(item => {
                const full = this.formData[item.field];
                if (full) {
                    this[item.dateField] = full.slice(0, 10);
                    this.hourData[item.field] = full.slice(11, 13);
                } else {
                    this[item.dateField] = today;
                }
            });
        },
        pad2(num) {
            return num < 10 ? '0' + num : '' + num;
        },
        randomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        randomTimeInHour(date, hour) {
            return `${date} ${hour}:${this.pad2(this.randomInt(0, 59))}:${this.pad2(this.randomInt(0, 59))}`;
        },
        generateTime(field, dateField) {
            const date = this[dateField];
            const hour = this.hourData[field];
            if (!date) {
                this.$message.warning('请先选择日期');
                return;
            }
            if (!hour) {
                this.$message.warning('请先选择小时');
                return;
            }
            const startFieldMap = {
                slkssj: '',
                sljssj: 'slkssj',
                xlkssj: 'sljssj',
                xljssj: 'xlkssj',
            };
            const startField = startFieldMap[field];
            if (startField && this.formData[startField]) {
                this.formData[field] = this.randomEndAfter(date, hour, this.formData[startField]);
            } else {
                this.formData[field] = this.randomTimeInHour(date, hour);
            }
        },
        generateAll() {
            const today = this.getTodayStr();
            if (!this.value1) {
                this.value1 = today;
            }
            if (!this.value2) {
                this.value2 = today;
            }
            if (!this.value3) {
                this.value3 = today;
            }
            if (!this.value4) {
                this.value4 = today;
            }
            this.autoFillHours();
            this.formData.slkssj = this.randomTimeInHour(this.value1, this.hourData.slkssj);
            this.formData.sljssj = this.randomEndAfter(this.value2, this.hourData.sljssj, this.formData.slkssj);
            this.formData.xlkssj = this.randomEndAfter(this.value3, this.hourData.xlkssj, this.formData.sljssj);
            this.formData.xljssj = this.randomEndAfter(this.value4, this.hourData.xljssj, this.formData.xlkssj);
        },
        autoFillHours() {
            const fields = ['slkssj', 'sljssj', 'xlkssj', 'xljssj'];
            fields.forEach((field, index) => {
                if (this.hourData[field]) {
                    return;
                }
                let low = -1;
                for (let i = index - 1; i >= 0; i--) {
                    if (this.hourData[fields[i]]) {
                        low = Number(this.hourData[fields[i]]);
                        break;
                    }
                }
                let high = 24;
                for (let i = index + 1; i < fields.length; i++) {
                    if (this.hourData[fields[i]]) {
                        high = Number(this.hourData[fields[i]]);
                        break;
                    }
                }
                const min = low + 1;
                const max = high - 1;
                if (min > max) {
                    this.hourData[field] = this.pad2(Math.max(0, Math.min(23, min)));
                } else {
                    this.hourData[field] = this.pad2(this.randomInt(min, max));
                }
            });
        },
        randomEndAfter(date, hour, startStr) {
            const sameHour = startStr && startStr.slice(0, 13) === `${date} ${hour}`;
            if (!sameHour) {
                return this.randomTimeInHour(date, hour);
            }
            const startMinute = Number(startStr.slice(14, 16));
            const startSecond = Number(startStr.slice(17, 19));
            const startTotalSec = startMinute * 60 + startSecond;
            const maxTotalSec = 3599;
            let totalSec;
            if (startTotalSec >= maxTotalSec) {
                totalSec = maxTotalSec;
            } else {
                totalSec = this.randomInt(startTotalSec + 1, maxTotalSec);
            }
            return `${date} ${hour}:${this.pad2(Math.floor(totalSec / 60))}:${this.pad2(totalSec % 60)}`;
        },
        disabledEndDate1(date) {
            return this.isBeforeStartDate(date, this.value1);
        },
        disabledEndDate2(date) {
            return this.isBeforeStartDate(date, this.value3);
        },
        disabledEndDate3(date) {
            return this.isBeforeStartDate(date, this.value2);
        },
        isBeforeStartDate(date, startStr) {
            if (!startStr) {
                return false;
            }
            const [y, m, d] = startStr.split('-').map(Number);
            const start = new Date(y, m - 1, d).getTime();
            const day = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
            return day < start;
        },
        isEndHourDisabled1(hour) {
            if (this.value2 !== this.value1) {
                return false;
            }
            const startHour = this.hourData.slkssj;
            if (!startHour) {
                return false;
            }
            return Number(hour) < Number(startHour);
        },
        isEndHourDisabled2(hour) {
            if (this.value4 !== this.value3) {
                return false;
            }
            const startHour = this.hourData.xlkssj;
            if (!startHour) {
                return false;
            }
            return Number(hour) < Number(startHour);
        },
        isUnloadStartHourDisabled(hour) {
            if (this.value3 !== this.value2) {
                return false;
            }
            const endHour = this.hourData.sljssj;
            if (!endHour) {
                return false;
            }
            return Number(hour) < Number(endHour);
        },
        openSelectTable(tableCode, callBackName) {
            if (tableCode === 'ycl_gbdgl_xzlc' && (this.formData.gbdbh || '') === '') {
                this.$message.warning('请先选择过磅单');
                return;
            }
            this.$toast({
                title: true,
                type: 'eject',
                t_url: 'tableList/index',
                width: '79%',
                height: '88%',
                extr: {
                    code: {
                        TableCode: tableCode,
                        QueryString: tableCode === 'ycl_gbdgl_xzlc' ? `balance_number=${this.formData.gbdbh}` : '',
                    },
                    selectTypeCallback: this[callBackName],
                },
            });
        },
        selectWeighingSlipBack(data) {
            this.formData.gbdbh = data.balance_number;
            this.formData.gydh = data.task_number;
            this.formData.cph = data.plate_number;
            this.formData.czbm = data.station_id;
            this.formData.czmc = data.station_name;

            this.formData.lcbh = '';
            this.formData.lcmc = '';
            this.formData.yclmc = '';
        },
        selectSiloBack(data) {
            this.formData.lcbh = data.stock_code;
            this.formData.lcmc = data.stock_name;
            this.formData.yclmc = data.child_type_name;
        },
        selectDischargePort(data) {
            this.formData.flkmc = this.portMap[data];
        },
        async save() {
            if (!this.validateForm()) {
                return;
            }
            const res = await this.saveFormRequest(this.formData);
            if (res) {
                this.$message.success('保存成功');
                this.$updateTable();
                this.$parent.hide();
            }
        },
        validateForm() {
            const required = [
                { field: 'gbdbh', msg: '请先选择过磅单' },
                { field: 'cph', msg: '请选择车牌号' },
                { field: 'lcbh', msg: '请选择料仓' },
                { field: 'flkbm', msg: '请选择放料口' },
                { field: 'slkssj', msg: '请生成上料开始时间' },
                { field: 'sljssj', msg: '请生成上料结束时间' },
                { field: 'xlkssj', msg: '请生成车辆卸料开始时间' },
                { field: 'xljssj', msg: '请生成车辆卸料结束时间' },
            ];
            for (let i = 0; i < required.length; i++) {
                if (!this.formData[required[i].field]) {
                    this.$message.warning(required[i].msg);
                    return false;
                }
            }
            return true;
        },
        Close() {
            this.$parent.hide();
        },

        initRequest(id) {
            return this.$axios.$get(`/interfaceApi/procurement/materialsupply/get/${id}`, { defEx: true });
        },

        saveFormRequest(data) {
            return this.$axios.$post('/interfaceApi/procurement/materialsupply/save', data, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.supplementaryRegistrationForm
    height 100%
    background #fff
    overflow-y hidden
    .supplementaryRegistrationFormContent
        overflow auto
        padding 20px
        height calc(100% - 80px)
        .table-container
            width 100%
            margin-bottom 20px
            &:last-child
                bottom 0
            .custom-table
                border-spacing 0px
                border-collapse collapse
                width 100%
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button
                    -webkit-appearance none !important
                td,th
                    height 48px
                    font-size 16px
                    padding 8px
                    padding: 4px
                    border 1px solid #D7D7D7
                    box-shadow: inset 0px 0px 0px 4px #fff;
                td
                    .el-input
                        height 38px
                        line-height 38px
                        .el-input__suffix
                            line-height 38px
                        &.is-disabled
                            input
                                color #333
                    .el-select
                        width 100%
                        .el-input
                            .el-input__suffix
                                line-height 34px
                    .el-button
                        height 38px
                    .el-radio-group
                        padding-left 10px
                .table-tit
                    height 58px
                    font-size 18px
                    text-align: left
                    background: #eef3f8
                    padding 0
                    box-shadow none
                    background: none
                    padding-bottom 12px
                    position: relative
                    border none
                    &:before
                        content ''
                        width 100%
                        height 2px
                        background #0062B5
                        position absolute
                        bottom 10px
                        left 0
                    span
                        font-family: AliHYAiHei
                        font-size: 16px;
                        color: #fff;
                        height: 46px;
                        line-height: 46px;
                        background: #0062B5;
                        padding: 0 20px;
                        display: inline-block;
                        position: relative;
                        &:after
                            content:'';
                            width: 44px;
                            height: 47px;
                            background: url(./../../../assets/images/popUpForm/tableHeaderBg.png) no-repeat;
                            background-size: 100%;
                            position: absolute;
                            left: 100%;
                    .title-btn
                        position absolute
                        right 0
                        top 5px
                        height 32px
                        line-height 32px
                        padding 0 15px
                        font-size 14px
                        color #1577D2
                        border 1px solid #1577D2
                        background #fff
                        cursor pointer
                .column-tit
                    text-align right
                    color #022782
                    background #F5F6F7
                    line-height 36px
                .selectTime
                    display flex
                    align-items center
                    .el-date-editor
                        width 57%
                    .el-select
                        width 28%
                    .el-button
                        width 15%
    footer
        height 80px
        padding 20px
        text-align center
        button
            width 200px
            height 42px
            line-height 42px
            padding 0
            font 16px '微软雅黑'
            margin 0 15px
            border none
            cursor pointer
            &.save
                color #fff
                background #1577D2
            &.Close
                color #1577D2
                background #fff
                border 1px solid #1577D2
</style>
